import { Zap, Globe, Wifi, Video} from 'lucide-react';

const FeaturesSection = () => {

    const features = [
      {
        icon: <Zap className="w-8 h-8" />,
        title: 'Ultra Low Latency',
        description: 'Ping dibawah 10ms ke server game lokal',
        color: 'text-yellow-400'
      },
      {
        icon: <Globe className="w-8 h-8" />,
        title: 'Server Lokal Optimized',
        description: 'Routing khusus ke server game Indonesia',
        color: 'text-green-400'
      },
      {
        icon: <Wifi className="w-8 h-8" />,
        title: 'Dedicated Bandwidth',
        description: 'Bandwidth khusus gaming, gak dibagi',
        color: 'text-blue-400'
      },
      {
        icon: <Video className="w-8 h-8" />,
        title: 'Streaming Ready',
        description: 'Upload speed tinggi untuk streaming',
        color: 'text-blue-600'
      }
    ];

return (
 <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-black text-center mb-16">
              <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                Gaming Features
              </span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => (
                <div key={index} className="group bg-gray-800/40 backdrop-blur-md p-8 rounded-2xl border border-gray-700 hover:border-cyan-500/50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/10">
                  <div className={`${feature.color} mb-6 transform group-hover:scale-110 transition-transform`}>
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-4 text-white">{feature.title}</h3>
                  <p className="text-gray-300">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
    );
};
export default FeaturesSection;